(ns minorodata.connections.sources.polaris
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description (spec/nilable string?))


(spec/def ::user-name
  (spec/and (st/spec string? {:reason "Please provide a valid user-name"})
            (st/spec (complement c.string/blank?) {:reason "User name can't be empty"})))


(spec/def ::password
  (spec/and (st/spec string? {:reason "Please provide a password for the source"})
            (st/spec (complement c.string/blank?) {:reason "Password can't be empty"})))


(spec/def ::account-name
  (spec/and (st/spec string? {:reason "Please provide an account name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Account name can't be empty"})))


(spec/def ::polaris-form
  (spec/and
   (spec/keys :req-un [::name ::user-name ::password ::account-name]
              :opt-un [::description])))

(def source
  {:enabled      true
   :id           "polaris"
   :name         "Polaris"
   :image-source "polaris-logo.png"
   :description  "Cash Control & Workforce Management Software"
   :tags         ["admin-finance"]


   :preview-formatter
   (fn []
     (str "Authenticated by username and password"))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [account-name user-name password name description]} data]
        {:source-type "polaris"
         :name        name
         :description description

         :source
         {:account-name account-name
          :credentials  {:user-name user-name
                         :password  password}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [account-name credentials]} source
            {:keys [user-name password]} credentials]
        {:name         name
         :description  description
         :account-name account-name
         :user-name    user-name
         :password     password}))

    :validate (partial form-component/validate-form ::polaris-form)

    :id :polaris-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :input
              :label      "Account name"
              :name       :account-name
              :required   true
              :value      ""}

             {:block-type :input
              :label      "User name"
              :name       :user-name
              :required   true
              :value      ""}

             {:block-type :input
              :label      "Password"
              :name       :password
              :type       :password
              :required   true
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status
                 report action destination-table extract-type]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action            action
                    :report            report
                    :extract-type      extract-type
                    :destination-table destination-table}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:destination-table :report :action :extract-type])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :polaris-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Daily Sales Breakdown"  :value "daily-sales-breakdown"}
                           {:name "Daily Discounts Breakdown" :value "daily-discounts-breakdown"}
                           {:name "Complete Hourly Wage Costs" :value "complete-hourly-wage-costs"}
                           {:name "Sales Forecast" :value "sales-forecast"}]
              :required   true
              :value      "daily-sales-breakdown"}


             {:block-type :select
              :label      "Extract type"
              :name       :extract-type
              :options    [{:name "Full"        :value "full-load"}
                           {:name "Incremental" :value "incremental"}]
              :required   true
              :value      "full-load"}

             {:content "Incremental will fetch all data that was modified since the last extract was run. Good for tracking change"
              :conditions [[:eq [:extract-type :value] "incremental"]]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "full-load"]]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
